import {
  boundaryTerritoryGroupHighlightStarted, boundaryTerritoryGroupInSidebarHighlightFinished,
} from './boundarySidebarState.actionCreators';

type BoundarySidebarHighlightState = {
  highlightedBoundaryTerritoryGroupId: number | null;
};

const initialState: BoundarySidebarHighlightState = {
  highlightedBoundaryTerritoryGroupId: null,
};

export const boundarySidebarStateReducer = (state: BoundarySidebarHighlightState = initialState,
  action: Action): BoundarySidebarHighlightState => {
  if (boundaryTerritoryGroupHighlightStarted.match(action)) {
    return {
      ...state,
      highlightedBoundaryTerritoryGroupId: action.payload.boundaryGroupId,
    };
  }

  if (boundaryTerritoryGroupInSidebarHighlightFinished.match(action)) {
    return {
      ...state,
      highlightedBoundaryTerritoryGroupId: initialState.highlightedBoundaryTerritoryGroupId,
    };
  }

  return state;
};
